import FleetModal, { useAsyncModal } from '@/libs/antd/components/Modal';
import FleetTitle from '@/libs/antd/components/Title';
import { useForm } from '@/libs/antd/form';
import ANTD_DEFAULT_PROPS from '@/libs/antd/props';
import rule from '@/libs/antd/rules';
import { Col, Divider, Form, Input, InputNumber, Row, Select } from 'antd';
import { FC } from 'react';
import { NAPCompanyGroupShareholderForm } from '../NAPPage.CompanyGroup';
import { useSelectManagementPosition } from '@/libs/fleet-api/hooks/master-data';
import { inputCurrency } from '@/libs/antd/input-number';

export const useCompanyShareholderModal = () => {
	return useAsyncModal<
		NAPCompanyGroupShareholderForm,
		NAPCompanyGroupShareholderForm
	>();
};

const CompanyShareholderModal: FC<
	ReturnType<typeof useCompanyShareholderModal>
> = (props) => {
	const { form, fieldName } = useForm<NAPCompanyGroupShareholderForm>();
	const selectPosition = useSelectManagementPosition();

	return (
		<FleetModal
			{...props.modal}
			width={940}
			closable={false}
			buttonPosition="end"
			okText="SAVE"
			cancelText="BACK"
			onOk={async () => {
				const values = await form.validateFields();
				props.close(values);
			}}
			afterOpenChange={(isOpen) => {
				if (!isOpen) {
					form.resetFields();
				} else if (props.data) {
					form.setFieldsValue(props.data);
				}
			}}
		>
			<FleetTitle>Add Susunan Pemegang Saham Informasi Umum Group</FleetTitle>
			<Form
				{...ANTD_DEFAULT_PROPS.FORM}
				form={form}
			>
				<Form.Item
					name={fieldName('id')}
					noStyle
				/>
				<Form.Item
					name={fieldName('managementId')}
					noStyle
				/>
				<Form.Item
					name={fieldName('isManagement')}
					noStyle
				/>

				<Row
					gutter={40}
					style={{ marginTop: 20 }}
				>
					<Col span={12}>
						<Form.Item
							label="Nama"
							name={fieldName('name')}
							rules={[rule.required()]}
						>
							<Input />
						</Form.Item>
					</Col>
					<Col span={12}>
						<Form.Item
							name={fieldName('position')}
							label="Jabatan"
							rules={[rule.required()]}
							getValueFromEvent={(_, option) => option?.data}
							getValueProps={(value) => {
								if (!value) return {};
								return {
									value: {
										value: value.id,
										label: value.value,
									},
								};
							}}
						>
							<Select {...selectPosition} />
						</Form.Item>
					</Col>
				</Row>
				<Divider />
				<Row
					gutter={40}
					style={{ marginTop: 20 }}
				>
					<Col span={12}>
						<Form.Item
							label="Saham (lembar)"
							name={fieldName('shareAmount')}
							rules={[rule.required()]}
						>
							<InputNumber min={0} />
						</Form.Item>
					</Col>
					<Col span={12}>
						<Form.Item
							label="Nilai (Rp)"
							name={fieldName('shareValue')}
							rules={[rule.required()]}
						>
							<InputNumber {...inputCurrency} />
						</Form.Item>
					</Col>
				</Row>
				<Divider />
				<Row
					gutter={40}
					style={{ marginTop: 20 }}
				>
					<Col span={12}>
						<Form.Item
							label="Porsi (%)"
							name={fieldName('shareholding')}
							rules={[rule.required()]}
						>
							<InputNumber
								min={0}
								max={100}
								suffix="%"
							/>
						</Form.Item>
					</Col>
				</Row>
			</Form>
		</FleetModal>
	);
};

export default CompanyShareholderModal;
